import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ProgressSpinner } from "primeng/progressspinner";
import { TagModule } from "primeng/tag";
import { Button } from "primeng/button";
import { InspectionJobDetail } from "../../../../../domains/jobs/models/InspectionJobDetail";
import { NetworkStatusService } from "../../../../../shared/services/network-status.service";
import JobDataService from "../../../../../domains/jobs/services/job-data-service";
import SyncManager from "../../../../../core/sync/sync-manager";
import { Bq9DataService } from "../services/bq9-data.service";
import { JobService } from "../../../../../domains/jobs/services/job.service";

@Component({
  selector: "app-bq9-submission",
  imports: [ProgressSpinner, TagModule, Button],
  templateUrl: "./bq9-submission.component.html",
  styleUrl: "./bq9-submission.component.scss"
})
export class Bq9SubmissionComponent implements OnInit, OnDestroy {

  isOnline: boolean = true;
  submissionFinished: boolean = false;
  inspectionJob!: InspectionJobDetail;
  private jobId!: number;

  private syncServiceSubscription!: Subscription;
  private syncFailedSubscription!: Subscription;
  private onlineSubscription?: Subscription;
  private minTimeElapsed = false;
  maxTimeoutElapsed = false;
  private syncDone = false;

  private readonly MIN_TIME = 3000; // 3s
  private readonly MAX_TIME = 30000; // 30s
  private maxSyncTimeoutId: number | null = null;

  constructor(
    private networkService: NetworkStatusService,
    private router: Router,
    private jobDataService: JobDataService,
    private syncService: SyncManager,
    private bq9DataService: Bq9DataService,
    private jobService: JobService
  ) {
    this.onlineSubscription = this.networkService.online$.subscribe(val => {
      this.isOnline = val;
    });

    this.syncServiceSubscription = this.syncService.onSyncCompleted.subscribe(() => {
      this.syncDone = true;
      this.checkSpinner();
    });

    this.syncFailedSubscription = this.syncService.onSyncFailed.subscribe(() => {
      this.syncDone = true;
      this.checkSpinner();
    });
  }

  async ngOnInit() {
    const jobId = this.bq9DataService.job()?.id;

    if (!jobId) {
      return;
    }

    this.jobId = jobId;

    const job = await this.jobDataService.getInspectionJobDetailByJobId(this.jobId);

    if (!job) {
      return;
    }

    if (job.isComplete) {
      this.router.navigate(["/cm/lot", job.lotId, "open-items"]);
    }

    this.inspectionJob = job;
    this.inspectionJob.updatedAt = new Date();

    await this.jobService.markJobAsComplete(this.jobId, this.inspectionJob.updatedAt);

    if (this.isOnline) {
      setTimeout(() => {
        this.minTimeElapsed = true;
        this.checkSpinner();
      }, this.MIN_TIME);

      this.maxSyncTimeoutId = window.setTimeout(() => {
        this.maxTimeoutElapsed = true;
        this.checkSpinner();
      }, this.MAX_TIME);

      this.syncService.manuallyTriggerSync();
    }
  }

  private checkSpinner() {
    if (this.minTimeElapsed && (this.syncDone || this.maxTimeoutElapsed)) {
      this.submissionFinished = true;
      if (this.maxSyncTimeoutId) {
        clearTimeout(this.maxSyncTimeoutId);
      }
    }
  }

  ngOnDestroy() {
    if (this.syncServiceSubscription) {
      this.syncServiceSubscription.unsubscribe();
    }
    if (this.syncFailedSubscription) {
      this.syncFailedSubscription.unsubscribe();
    }
    this.onlineSubscription?.unsubscribe();
  }

  async clickOnDone() {
    this.router.navigate(["/cm/schedule"]);
  }
}
